module.exports = __webpack_public_path__ + "static/media/ramen_dschungel.fcdec2ef.png";